import { render, staticRenderFns } from "./SetEntrance.vue?vue&type=template&id=3c5f9587&scoped=true&"
import script from "./SetEntrance.vue?vue&type=script&lang=js&"
export * from "./SetEntrance.vue?vue&type=script&lang=js&"
import style0 from "./SetEntrance.vue?vue&type=style&index=0&id=3c5f9587&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f9587",
  null
  
)

export default component.exports